/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Features_Upload_Research_PapersInputs */

const en_features_upload_research_papers = /** @type {(inputs: Features_Upload_Research_PapersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Research Papers`)
};

const es_features_upload_research_papers = /** @type {(inputs: Features_Upload_Research_PapersInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Artículos de investigación`)
};

/**
* | output |
* | --- |
* | "Research Papers" |
*
* @param {Features_Upload_Research_PapersInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const features_upload_research_papers = /** @type {((inputs?: Features_Upload_Research_PapersInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Features_Upload_Research_PapersInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_features_upload_research_papers(inputs)
	return en_features_upload_research_papers(inputs)
});